/* eslint-disable import/prefer-default-export */
export function normalizeEligibilityResponse(response) {
  return {
    text: response?.response || response?.message || "",
    threadId: response?.thread_id,
    raw: response,
  };
}
